// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MoreSvg from '@rsuite/icon-font/lib/application/More';
var More = createSvgIcon({
    as: MoreSvg,
    ariaLabel: 'more',
    category: 'application',
    displayName: 'More'
});
export default More;
